<template>
    <div>
        <img class="bg-imgs" :src="item" v-for="(item,index) in bg" :key="index" :class="{
                    'blockImg':index == selectIndex ,
                    'currentImg':index == selectIndex && timer ,
                    'nextImg':(selectIndex+1)%bg.length==index && timer 
                }" />
    </div>
</template>

<script>
import { resetImgSizeWH } from '../axios/utils'


/* 图片加载完成自相应 */
if ( window.addEventListener ) {
    window.addEventListener("load", function(){onload();}, false);
} else if ( window.attachEvent ) {
    window.attachEvent( "onload", function(){onload();} );
} else if ( window.onload ) {
    window.onload = function(){onload();};
}

window.onresize = function(){
    onload();
}

/* 图片自相应处理 */
function onload(){    
    console.log(1)
    var imgs = document.querySelectorAll(".bg .bg-imgs") || [];
    if(imgs.length>0){
        var height = imgs[0].height;
        for(let i=0;i<imgs.length;i++){
            var img = imgs[i];
            // resetImgSizeWH(img,img.naturalWidth, img.naturalHeight, img.width, img.height)
            resetImgSizeWH(img,img.naturalWidth, img.naturalHeight, document.body.clientWidth, height)
        }
    }
}
export default {
    props: ['bg', 'selectIndex', 'timer']
}

/* 浏览器窗口改版事件 */
window.onresize = function(){
    onload();
}
</script>

<style scoped>


.bg-imgs {
    position: absolute;
    width: 100%;
    height: 100%;
    display: none;
}

.blockImg {
    display: inline;
}

.currentImg {
    animation: changePosition 5s ease-in-out 0s;
}

.nextImg {
    display: inline;
    animation: changeNextPosition 5s ease-in-out 0s;
}


/*区分IE9以上，不包括IE9*/


/* @media screen and (-ms-high-contrast: active),(-ms-high-contrast: none) {
    :root .nextImg {
        display: inline;
    }
} */

@keyframes changePosition {
    0% {
        display: none;
        transform: translate(0, 0);
        -ms-transform: translate(0, 0);
        -moz-transform: translate(0, 0);
        -webkit-transform: translate(0, 0);
        -o-transform: translate(0, 0);
    }
    70% {
        display: none;
        transform: translate(0, 0);
        -ms-transform: translate(0, 0);
        -moz-transform: translate(0, 0);
        -webkit-transform: translate(0, 0);
        -o-transform: translate(0, 0);
    }
    100% {
        transform: translate(-100%, 0);
        -ms-transform: translate(-100%, 0);
        -moz-transform: translate(-100%, 0);
        -webkit-transform: translate(-100%, 0);
        -o-transform: translate(-100%, 0);
    }
}

@keyframes changeNextPosition {
    0% {
        display: none;
        transform: translate(100%, 0);
        -ms-transform: translate(100%, 0);
        -moz-transform: translate(100%, 0);
        -webkit-transform: translate(100%, 0);
        -o-transform: translate(100%, 0);
    }
    70% {
        display: none;
        transform: translate(100%, 0);
        -ms-transform: translate(100%, 0);
        -moz-transform: translate(100%, 0);
        -webkit-transform: translate(100%, 0);
        -o-transform: translate(100%, 0);
    }
    100% {
        transform: translate(0, 0);
        -ms-transform: translate(0, 0);
        -moz-transform: translate(0, 0);
        -webkit-transform: translate(0, 0);
        -o-transform: translate(0, 0);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/a.header.img.leftright.vue